<div
  class="alert alert-success d-flex"
  style="justify-content: space-between; align-items: center"
  role="alert"
>
  <div class="d-flex">
    <img src="assets/images/icons/circle-check-filled.svg" />
    <span class="mx-2">{{ message }}</span>
  </div>
  <i (click)="close()" class="fa fa-close" style="cursor: pointer"></i>
</div>
